<template>
  <v-card
    class="p-orderCard"
    depressed
    ripple
    elevation="0"
    @click="$emit('clicked-card', order)"
  >
    <v-card-text class="px-3 py-2">
      <v-chip v-if="order.reccomend" label color="error" small outlined>
        <v-icon small left> mdi-star-outline </v-icon>
        PICK UP
      </v-chip>
      <div class="d-flex justify-space-between">
        <div class="p-orderCard__mainInfo">
          <h2 class="p-orderCard__title">
            {{ order.title }}
          </h2>
          <h3 class="p-orderCard__query">
            検索クエリ：<span>{{ order.query }}</span>
          </h3>
          <div class="p-orderCard__requiredWords">
            <span class="p-orderCard__requiredWords--number">
              {{ order.requiredWords }}
            </span>
            文字〜
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="sass">
.p-orderCard
  &:hover
    opacity: .5
  &__mainInfo
    padding-top: 10px
  &__title
    font-weight: 500
    color: #222222
    font-size: 16px
    letter-spacing: 2px
  &__query
    color: #404040
    margin-top: 10px
    font-size: 14px
    span
      font-weight: 500
  &__pickUpFlag
    display: inline-block
    font-weight: bold
    font-style: italic
    margin-bottom: 5px
    padding: 3px 10px
    border-bottom: 1px solid red
  &__requiredWords
    margin: 8px 0
    font-size: 10px
    vertical-align: middle
    &--number
      color: #1a1a1a
      font-size: 16px
      letter-spacing: 2px
      line-height: 25px
</style>
